import I18n from "../../I18n";
import jsesc from "jsesc";

export const handleReprocessRepository = (props) => {
    const {
        pushDialog,
        i18n,
        params,
        reprocessRepository,
        user,
        repositoryStatus,
        pushNotification,
    } = props;

    pushDialog("ConfirmDialog", i18n`Process All`, {
        title: i18n`Are you sure you want to process repository?`,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            if (
                repositoryStatus &&
                (!repositoryStatus.fiscalYear ||
                    !repositoryStatus.fileType ||
                    repositoryStatus.repoStatus === 2 ||
                    repositoryStatus.autoMerge === 1)
            ) {
                pushNotification({
                    open: true,
                    message: i18n`No need to reprocess the repository`,
                    type: "error",
                    timeout: "short",
                });
                return;
            }
            reprocessRepository({
                fiscalYear: repositoryStatus.fiscalYear,
                projectId: params.projectId,
                fileType: repositoryStatus.fileType,
                userId: user.id,
            })
                .then((res) => res.json().catch(() => ({})))
                .then((res) => {
                    if (res && res.data && res.data.reprocess_repository) {
                        pushNotification({
                            open: true,
                            message: i18n`Starting reprocessing the repository`,
                            type: "confirmation",
                            timeout: "short",
                            onClose: () => {
                                res && window.location.reload();
                            },
                        });
                    } else {
                        const { errors } = res;
                        const error =
                            (errors && errors[0] && errors[0].message) || "error processing";

                        pushNotification({
                            open: true,
                            message: i18n`${jsesc(error)}`,
                            type: "error",
                            timeout: "short",
                        });
                    }
                })
                .catch(() => null);
        })
        .catch(() => null);
};

export const handleAssociationEntityToPackage = (props) => {
    const {
        pushDialog,
        i18n,
        checkList,
        params,
        saveWorkerAssociationPackage,
        setCurrentCheckedList,
        setOriginalCheckedList,
        pushNotification,
    } = props;

    const selectedFiles = [];
    const removedFiles = [];

    for (const item of checkList) {
        if (item.checked) {
            selectedFiles.push(parseInt(item.id));
        } else {
            removedFiles.push(parseInt(item.id));
        }
    }

    const entityTitle = {
        package_custom_reports: "associate_confirm_message_package_custom_reports",
        package_kpis: "associate_confirm_message_package_kpis",
        package_rules: "associate_confirm_message_package_rules",
    };

    pushDialog("ConfirmDialog", i18n`Package Associate`, {
        title: i18n`${entityTitle[params.entity]}`,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            saveWorkerAssociationPackage({
                entity: params.entity,
                packageId: params.id,
                selectItems: selectedFiles,
                removedItems: removedFiles,
            })
                .then((res) => res.json().catch(() => ({})))
                .then((res) => {
                    if (res && res.data && res.data.save_worker_association_package) {
                        setCurrentCheckedList(undefined);
                        setOriginalCheckedList(undefined);

                        pushNotification({
                            open: true,
                            message: I18n.translate`Package Associated`,
                            type: "confirmation",
                            timeout: "short",
                            onClose: () => {
                                window.location.reload();
                            },
                        });
                    } else {
                        const { errors } = res;
                        const error =
                            (errors && errors[0] && errors[0].message) || "error processing";
                        pushNotification({
                            open: true,
                            message: I18n.translate`${jsesc(error)}`,
                            type: "error",
                            timeout: "short",
                        });
                    }
                })
                .catch((e) => {
                    return null;
                });
        })
        .catch(() => null);
};


export const handleRequestDataForOrganizations = (props, fiscalYear) => {
    const {
        pushDialog,
        i18n,
        organizationId,
        requestDataForOrganizations,
        user,
        pushNotification,
    } = props;

    pushDialog("ConfirmDialog", i18n`Calculate Report`, {
        title: i18n`This process will overwrite data for this Report!`,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            requestDataForOrganizations({
                fiscalYear,
                organizationId: organizationId,
                userId: user.id,
            })
                .then((res) => res.json().catch(() => ({})))
                .then((res) => {
                    if (res && res.data && res.data.request_data_for_organization) {
                        pushNotification({
                            open: true,
                            message: I18n.translate`Data Requested`,
                            type: "confirmation",
                            timeout: "short",
                            onClose: () => { window.location.reload() },
                        });
                    } else {
                        const { errors } = res;
                        const error =
                            (errors && errors[0] && errors[0].message) || "error processing";
                        pushNotification({
                            open: true,
                            message: I18n.translate`${jsesc(error)}`,
                            type: "error",
                            timeout: "short",
                        });
                    }
                })
                .catch(() => null);
        })
        .catch(() => null);
};
